// extracted by mini-css-extract-plugin
export var activeDot = "_4e-c";
export var buttonContainer = "_4e-9";
export var channelButton = "_4e-a";
export var clickable = "_4e-d";
export var content = "_4e-0";
export var contentFull = "_4e-2";
export var contentThird = "_4e-1";
export var contentWrapper = "_4e-7";
export var description = "_4e-5";
export var heightShort = "_4e-f";
export var image = "_4e-3";
export var imageContainer = "_4e-4";
export var selectButton = "_4e-e";
export var spinnerContainer = "_4e-b";
export var titleContent = "_4e-8";
export var titleWrapper = "_4e-6";